import script from "./PartyTermsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PartyTermsDialog.vue?vue&type=script&setup=true&lang=js"

import "./PartyTermsDialog.vue?vue&type=style&index=0&id=1d824485&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d824485"]])

export default __exports__